var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstall5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 29.5,
    width: 151,
    height: 88,
    rx: 2.5,
    fill: "white",
    stroke: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 31.5,
    width: 147,
    height: 84,
    rx: 1.5,
    fill: "white",
    stroke: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 117.5H95.2727L88 130.5H91.3939L104 117.5Z",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206 117.5H214.727L222 130.5H218.606L206 117.5Z",
    stroke: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.023 64.9429C141.48 46.862 171.029 46.862 189.487 64.9429L156.255 98.1751L123.023 64.9429Z",
    stroke: "#13AE67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstall5);
export default __webpack_public_path__ + "static/media/ic-install-5.24cafdcfbed0a7b080abd6635d555ca4.svg";
export { ForwardRef as ReactComponent };